$(function () {
    const $hint = $('#packetFilterHint');

    if ($hint.length === 0) {
        return;
    }

    $('.packet-filter-hint-trigger').on('click', function (e) {
        e.preventDefault();
        $hint.toggle();
    });

    $('.packet-filter-hint-close-btn').on('click', function (e) {
        e.preventDefault();
        $hint.hide();
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('#packetFilterHint, .packet-filter-hint-trigger').length === 0) {
            $hint.hide();
        }
    });
});
